import { get } from '../components/shared/lib/axios';

var controllerRoute = 'RAGInterval';

export async function getRagInterval() {
    return get(controllerRoute);
}
